import { styled } from '@mui/material/styles';
import ButtonMui, { ButtonProps } from '@mui/material/Button';
import styles from './styles.module.scss';
import { useTranslation } from 'react-i18next';

interface CustomButtonProps {
  loading?: boolean;
  square?: boolean;
}

const CustomButton = (props: CustomButtonProps & ButtonProps) => {
  const { children, loading, square } = props;
  const { t } = useTranslation();
  const buttonMuiProps = { ...props, loading: undefined, square: undefined };
  return (
    <ButtonMui {...buttonMuiProps} sx={{ borderRadius: square ? '0px' : '5px' }}>
      {loading && <div className={styles.loading_btn} />}
      {loading ? <span>{t('common.processing')}</span> : children}
    </ButtonMui>
  );
};

export const Button = styled(CustomButton)<ButtonProps>(({ theme }) => ({
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: '700',
  fontSize: 14,
  textAlign: 'center',
  letterSpacing: '0.25em',
  padding: '14px 16px',
  transition: 'background 1s ease-out',
  '&:hover': {
    opacity: 0.8,
  },
}));
